import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { IColors } from '@src/types/theme';
import * as selectors from '@src/store/selectors';
import { PROGRESS_STATUS_DONE, PROGRESS_STATUS_IN_PROGRESS, PROGRESS_STATUS_UNDONE } from '@src/const/course';

import { ProgressCircleIcon } from '@src/components/common/icon';

const ProgressCircleWrapper = styled.div`
	position: relative;
	top: ${props => `-${props.index * 8 * 2}px`};
	display: flex;
	align-items: center;
	font-size: ${props => (props.isCurrentStep ? '14px' : '12px')};
	font-weight: ${props => (props.isCurrentStep ? 500 : 300)};
	${props => ({ ...props.wrapperStyle })};
`;

const ProgressText = styled.div`
	margin-left: 8px;
	color: ${props => (props.isCurrentStep ? props.theme.colors.primary : 'inherit')};
`;

interface IProgressCircle {
	index: number;
	isLast: boolean;
	status: string;
	text: string | JSX.Element;
}

const ProgressCircle = ({ index, isLast, status, text }: IProgressCircle): JSX.Element => {
	const { colors } = useSelector(selectors.getColorTheme) as { colors: IColors };
	const isCurrentStep = (status === PROGRESS_STATUS_IN_PROGRESS) || (isLast && (status === PROGRESS_STATUS_DONE));
	const outerColor = (status === PROGRESS_STATUS_UNDONE) ? '#DDDDDD' : colors.primary;
	const outerOpacity = (status === PROGRESS_STATUS_UNDONE) ? 1 : 0.5;
	const innerColor = (status === PROGRESS_STATUS_UNDONE) ? '#DDDDDD' : colors.primary;

	return (
		<ProgressCircleWrapper index={index} isCurrentStep={isCurrentStep}>
			<ProgressCircleIcon
				width={16}
				height={isCurrentStep ? 16 : 12}
				outerColor={outerColor}
				outerOpacity={outerOpacity}
				innerColor={innerColor}
			/>
			<ProgressText isCurrentStep={isCurrentStep}>{text}</ProgressText>
		</ProgressCircleWrapper>
	);
};

export default ProgressCircle;
